import CardRow from '../../components/CardRow/CardRow';
import CardRowCard from '../../components/CardRow/CardRowCard';
import React from 'react';
import UserDetailPage from '../UserDetailPage/components/UserDetailPage';
import FormWrapper from '../../components/CardRow/FormWrapper';
import useAppContext from '../../hooks/context/useAppContext';

const Profile = () => {
  const {
    getUser,
  } = useAppContext();
  const id = getUser()?.id;
  return (
    <FormWrapper>
      <CardRow>
        <CardRowCard>
          <UserDetailPage
            id={id}
          />
        </CardRowCard>
      </CardRow>
    </FormWrapper>
  );
};

export default Profile;
